export default theme => ({
  copyrightText: {
    margin: "0px 0px -5px",
  },
});
